import { CheckboxDataType, DropdownDataType, FacetSortingMode, RangeDataType } from "..";

export type FacetConfig =
    | { type: 'chip'; config: ChipFacetConfig }
    | { type: 'checkbox'; config: CheckboxFacetConfig }
    | { type: 'dropdown'; config: DropdownFacetConfig }
    | { type: 'range'; config: RangeFacetConfig };


interface ChipsFacetConfig {
    htmlId: string;
}

interface ChipFacetConfig {
    htmlId: string;
}

interface CheckboxFacetConfig {
    htmlId: string;
    fieldName: string;
    fieldTitle: string;
    dataType: CheckboxDataType;
    count?: number;
    sort?: FacetSortingMode;
}

interface DropdownFacetConfig {
    htmlId: string;
    fieldName: string;
    fieldTitle: string;
    dataType: DropdownDataType;
    count?: number;
    sort?: FacetSortingMode;
}

interface RangeFacetConfig {
    htmlId: string;
    fieldName: string;
    fieldTitle: string;
    dataType: RangeDataType;
    minValue: number;
    maxValue: number;
}